import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
} from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
  selector: 'beneficiary-death-insured',
  templateUrl: './beneficiary-death-insured.component.html',
  styleUrls: ['./beneficiary-death-insured.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
  standalone: false,
})
export class BeneficiaryDeathInsuredComponent implements OnInit {
  @Input() derrors = false;
  options: FormControlOption[] = [
    {
      value: 'CONJOINT',
      label:
        'Le conjoint de l’adhérent, ni divorcé, ni séparé de corps, à défaut son partenaire avec lequel il est lié par un Pacte civil de solidarité, à défaut les enfants nés ou à naître de l’adhérent, vivants et non renonçants ou représentés, par parts égales, à défaut les héritiers de l’adhérent.',
      suffix: { title: 'A' },
    },
    {
      value: 'ENFANTS',
      label:
        'Les enfants nés ou à naître de l’adhérent, vivants et non renonçants ou représentés, par parts égales, à défaut les héritiers de l’adhérent.',
      suffix: { title: 'B' },
    },
    {
      value: 'HERITIERS',
      label: 'Les héritiers légaux de l’assuré.',
      suffix: { title: 'A' },
    },
  ];
  constructor(
    private controlContainer: FormGroupDirective,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }
  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const isPledgeForChildren = pledge?.owners[0].child;

    if (isPledgeForChildren) {
      this.options = this.options.filter(
        option => option.value === 'HERITIERS',
      );
    } else {
      this.options = this.options.filter(
        option => option.value !== 'HERITIERS',
      );
    }
  }
}
